import React, { useEffect } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import SoundGroup from "./SoundGroup";

const audioUrl = "https://dc.icery.tw/mp3/audio.mp3";
export const audio = new Audio(audioUrl);

export const SpeechRecognitionOptions = {
  language: "zh-TW",
  continuous: true,
  interimResults: true,
};

function App() {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  useEffect(() => {
    if (!listening) {
      SpeechRecognition.startListening(SpeechRecognitionOptions);
    }
  }, [listening]);

  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }

  return (
    <div className="container">
      <h1 className="title">天道輪迴</h1>
      <p>👆這怎麼唸?</p>
      <p className="transcript">{transcript}</p>

      <div style={{ display: "flex", flexDirection: "row", width: "60%" }}>
        <div style={{ width: "60%" }}>
          <SoundGroup
            transcript={transcript}
            resetTranscript={resetTranscript}
          />
          <SoundGroup
            transcript={transcript}
            resetTranscript={resetTranscript}
          />
          <SoundGroup
            transcript={transcript}
            resetTranscript={resetTranscript}
          />
        </div>
        <div style={{ width: "40%" }}>
          <iframe
            src={`https://discord.com/widget?id=915479678725275649&theme=dark&timestamp=${new Date().getTime()}`}
            width="100%"
            height="500"
            sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
          ></iframe>
        </div>
      </div>
      <a
        href="https://www.buymeacoffee.com/Icery"
        target="_blank"
        className="coffee-link"
      >
        <span>☕請我喝咖啡</span>
      </a>
      <span>version 2.0.230715</span>
    </div>
  );
}

export default App;
